import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useAuthContext } from "../../context";
import { userImageURL } from "../../api/api";

const UploadProfilePicture = ({ onClose, onUploadSuccess }) => {
  const { token, fetchUser } = useAuthContext();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const MAX_SIZE_MB = 3;

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      toast.error(`File is too large. Maximum allowed size is ${MAX_SIZE_MB}MB.`);
      return;
    }

    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file.");
      return;
    }
  
    const formData = new FormData();
    formData.append("files", selectedFile); // unified naming
    setUploading(true);
  
    try {
      const uploadRes = await axios.post(
        `${userImageURL}?type=profile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      toast.success("Profile picture updated!");
  
      // close and notify immediately
      onUploadSuccess?.();
      onClose?.();
  
      // refresh the user in the background
      fetchUser().catch(console.error);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Upload failed.");
    } finally {
      setUploading(false);
    }
  };  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-md w-[90%] max-w-md text-center">
        <h3 className="text-lg font-semibold mb-4">Upload Profile Picture</h3>
        {previewUrl && (
          <img
            src={previewUrl}
            alt="Preview"
            className="w-24 h-24 rounded-full object-cover mx-auto mb-4 border"
          />
        )}
        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleFileChange}
          className="block w-full text-sm text-gray-500 border border-gray-300 rounded-md px-3 py-2 mb-3"
        />
        <div className="flex justify-between">
          <button onClick={onClose} className="text-gray-500">Cancel</button>
          <button
            onClick={handleUpload}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm"
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadProfilePicture;
